module.exports = __webpack_public_path__ + "static/media/two_tone_03b.a56f06dd.mp3";